import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userMenuLinks, mainMenuLinks } from './NavLinks.js';
import { jwtDecode } from "jwt-decode";

function Navbar() {
    const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null); // Seul un menu ouvert à la fois
    const [userRoles, setUserRoles] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('assistance-axa-token');
        if (token) {
            const decoded = jwtDecode(token);
            setUserRoles(decoded.roles || []);
        }
    }, [navigate]);

    const openUserDropDownMenu = () => {
        setIsUserDropdownOpen(!isUserDropdownOpen);
    };

    const toggleSubmenu = (name) => {
        setOpenMenu(openMenu === name ? null : name); // Ouvre le menu cliqué, ferme les autres
    };

    const handleNavigation = (path) => {
        navigate(path);
        setOpenMenu(null); // Ferme tous les menus
    };

    const hasRole = (requiredRoles) => {
        return requiredRoles.some(role => userRoles.includes(role));
    };

    return (
        <nav className="sticky top-0 z-50 w-full bg-axa-blue-400 border-sienna-400">
            <div className="flex flex-wrap items-center justify-between w-full p-4">
                <div className="flex items-center px-4 space-x-10 md:space-x-6">
                    <button
                        type="button"
                        className="flex text-sm text-right bg-white rounded-full hover:ring-4 ring-sienna-400"
                        onClick={openUserDropDownMenu}
                    >
                        <img className="w-8 rounded-full h-9" src="/img/profile.png" alt="user icon" />
                        <p className="p-2 font-semibold text-black">Menu utilisateur</p>
                    </button>
                    <div className={`z-50 ${!isUserDropdownOpen ? 'hidden' : 'absolute top-12 left-6'} my-4 text-base list-none divide-y rounded-lg shadow bg-axa-blue-400 divide-sienna-400`}>
                        <ul className="py-2" aria-labelledby="user-menu-button">
                            {userMenuLinks.map(link => (
                                <li key={link.name}>
                                    <button className="block w-full px-4 py-2 text-sm text-left text-white hover:bg-sienna-400" onClick={() => handleNavigation(link.path)}>
                                        {link.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="items-center justify-between w-full md:flex md:w-auto" id="navbar-user">
                    <ul className="flex flex-col p-4 mt-4 font-medium text-white border rounded-lg md:p-0 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 bg-axa-blue-400 border-sienna-400">
                        {userRoles.includes('Createur') && (
                            <>
                                <li className='flex items-center'>
                                    <button
                                        className="px-3 py-1 mx-auto font-bold text-white border rounded bg-sienna-400 hover:bg-white hover:text-sienna-400 border-sienna-400"
                                        onClick={() => handleNavigation('/contrat/ajouter-contrat')}
                                    >
                                        Créer un contrat
                                    </button>
                                </li>
                                <li className='flex items-center'>
                                    <button
                                        className="px-3 py-1 mx-auto font-bold text-white border rounded bg-sienna-400 hover:bg-white hover:text-sienna-400 border-sienna-400"
                                        onClick={() => handleNavigation('/contrat/estimer-contrat')}
                                    >
                                        Etablir un devis
                                    </button>
                                </li>
                            </>
                        )}
                        {mainMenuLinks.map(link => {
                            if (link.requiredRoles && !hasRole(link.requiredRoles)) return null;
                            return (
                                <li key={link.name} className="relative rounded-lg">
                                    <button
                                        className="flex items-center p-3 rounded-lg hover:bg-white hover:text-black focus:outline-none"
                                        onClick={() => link.submenu ? toggleSubmenu(link.name) : handleNavigation(link.path)}
                                    >
                                        {link.name}
                                        {link.submenu && (
                                            <span className="ml-2 text-xs">
                                                ▼
                                            </span>
                                        )}
                                    </button>
                                    {link.submenu && openMenu === link.name && (
                                        <ul className="absolute left-0 z-10 w-48 mt-2 rounded-md shadow-lg bg-axa-blue-400">
                                            {link.submenu.map(sub => {
                                                if (sub.requiredRoles && !hasRole(sub.requiredRoles)) return null;
                                                return (
                                                    <li key={sub.name}>
                                                        <button
                                                            className="block w-full px-4 py-2 text-sm text-left hover:bg-white hover:text-black"
                                                            onClick={() => handleNavigation(sub.path)}
                                                        >
                                                            {sub.name}
                                                        </button>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <a href="/" className="flex items-center px-4 space-x-3">
                    <img src="/img/axa_logo_open_white_rgb.png" className="h-12 px-2" alt="AXA Logo" />
                </a>
            </div>
        </nav>
    );
}

export default Navbar;